var React = require('react');

function BlogXBottomInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0.954102","width":"48","height":"32","rx":"10","fill":"#111111","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M32.1436 23.0312L26.5205 14.8354L26.5301 14.843L31.6001 8.96875H29.9058L25.7757 13.75L22.4958 8.96875H18.0523L23.302 16.6207L23.3014 16.62L17.7646 23.0312H19.4589L24.0507 17.7118L27.7001 23.0312H32.1436ZM21.8245 10.2472L29.714 21.7528H28.3714L20.4755 10.2472H21.8245Z","fill":"white","key":1})]);
}

BlogXBottomInline.defaultProps = {"width":"49","height":"32","viewBox":"0 0 49 32","fill":"none"};

module.exports = BlogXBottomInline;

BlogXBottomInline.default = BlogXBottomInline;
